import React, { Component } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
class Trends extends Component {
  constructor() {
    super();

    this.state = {
      guideState: "Expand Guide",
    };

    this.guideOnClick = this.guideOnClick.bind(this);
  }

  guideOnClick() {
    if (this.state.guideState == "Expand Guide")
      this.setState({ guideState: "Collapse Guide" });
    else this.setState({ guideState: "Expand Guide" });
  }
  render() {
    return (
      <div className="container mb-2">
        <div className="row">
          <Accordion className="accordion mt-2 mb-4" style={{ width: "100%" }}>
            <div className="internship-guide-container lfont">
              <div
                className="internship-header lfont col-12"
                id="headingOne"
                style={{ background: "0 0", border: "none", color: "#fff" }}
              >
                <div
                  className="title-container"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0 2px 42px 0 rgb(0 0 0 / 20%)",
                    padding: "15px 30px",
                    marginTop: "35px",
                  }}
                >
                  {/* <div className="text-content mr-0 mr-md-5"> */}
                  <div
                    style={{
                      color: "#475058",
                      fontWeight: "700",
                      fontSize: "2rem",
                    }}
                  >
                    <h6 className="lfont to-center-xs post-title internship-page-title mt-2">
                      See current trends on recruiting status of companies
                    </h6>
                  </div>
                  <div className="mb-2">
                    <Accordion.Toggle
                      as={Button}
                      onClick={this.guideOnClick}
                      variant="link"
                      eventKey="0"
                      style={{ display: "inline !important" }}
                    >
                      {this.state.guideState}
                    </Accordion.Toggle>
                    {/* </div> */}

                    {/* <Card.Link href="#">Card Link</Card.Link> */}
                  </div>
                </div>
                <Accordion.Collapse eventKey="0">
                  <Card.Body
                    style={{
                      // width: "80%",
                      WebkitBoxFlex: "0",
                      msFlex: "0 0 100%",
                      flex: "0 0 100%",
                      maxWidth: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                      color: "#42464a",
                      // backgroundColor: "#fff",
                      // borderRadius: "10px",
                      // boxShadow: "0 2px 42px 0 rgb(0 0 0 / 20%)",
                      padding: "15px",
                      marginTop: "35px",
                    }}
                  >
                    <Card.Title
                    //   style={{
                    //     color: "#475058",
                    //     fontWeight: "700 !important",
                    //     fontSize: "2rem",
                    //     fontFamily: "Nunito,serif",
                    //   }}
                    >
                      By Status.fyi team
                    </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      April 19, 2021
                    </Card.Subtitle>
                    <div className="socialmedia">
                      <ul>
                        <li>
                          <a href="#facebook">Facebook</a>
                        </li>
                        <li>
                          <a href="#twitter">Twitter</a>
                        </li>
                        <li>
                          <a href="#linkedin">Linkedin</a>
                        </li>
                      </ul>
                    </div>
                    {/* <Card.Text> */}
                    <Card.Body className="collapsed"></Card.Body>
                    {/* </Card.Text> */}
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}

export default Trends;
